import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  packages: [],
  currentPage: 1,
  limit: 20,
  hasMore: true,
};

const ecomPackageSlice = createSlice({
  name: "ecomPackages",
  initialState,
  reducers: {
    setPackages(state, action) {
      state.packages = [...state.packages, ...action.payload];
    },
    resetPackages(state) {
      state.packages = [];
      state.currentPage = 1;
      state.hasMore = true;
    },
    incrementPage(state) {
      state.currentPage += 1;
    },
    setHasMore(state, action) {
      state.hasMore = action.payload;
    },
  },
});

export const { setPackages, resetPackages, incrementPage, setHasMore } =
  ecomPackageSlice.actions;

export default ecomPackageSlice.reducer;
